import { appStorage } from './betaStorage'
import { users } from '../data/seed'
import type { User } from '../types'

const EXTRA_DEMO_USERS: User[] = [
  {
    id: 'u-leo',
    name: 'Leo',
    role: 'participant',
    title: 'Child Participant · NIXI™',
    color: '#fb923c',
    initials: 'LE',
  },
  {
    id: 'u-jnr',
    name: 'Lizzie',
    role: 'participant',
    title: 'Child Participant · Age 4 · NIXI™',
    color: '#8b5cf6',
    initials: 'LI',
  },
  {
    id: 'u-lillian',
    name: 'Lillian Carter',
    role: 'rep',
    title: 'Mum of Leo & Lizzie · Plan Nominee / Admin',
    color: '#a855f7',
    initials: 'LC',
  },
  {
    id: 'u-mia',
    name: 'Mia Roberts',
    role: 'allied_health',
    title: 'Speech Pathologist',
    color: '#0f9fa8',
    initials: 'MR',
  },
  {
    id: 'u-jordan',
    name: 'Jordan Blake',
    role: 'allied_health',
    title: 'Behaviour Support Practitioner',
    color: '#b06a9f',
    initials: 'JB',
  },
  {
    id: 'u-olivia',
    name: 'Olivia Chen',
    role: 'allied_health',
    title: 'Occupational Therapist',
    color: '#2563eb',
    initials: 'OC',
  },
  {
    id: 'u-casey',
    name: 'Casey Morgan',
    role: 'support_worker',
    title: 'Independent Support Worker · Leo’s Team only',
    color: '#f59e0b',
    initials: 'CM',
  },
]

for (const user of EXTRA_DEMO_USERS) {
  if (!users.some((existing) => existing.id === user.id)) users.push(user)
}

const demoPhotos: Record<string, string> = {
  'u-leo': 'https://images.unsplash.com/photo-1639566420586-1b6d3d295f88?fm=jpg&ixlib=rb-4.0.3&q=80&w=600',
  'u-jnr': 'https://unsplash.com/photos/AS-WFs2Y8pA/download?force=true&w=480',
  'u-lillian': 'https://randomuser.me/api/portraits/women/47.jpg',
  'u-mia': 'https://randomuser.me/api/portraits/women/33.jpg',
  'u-jordan': 'https://randomuser.me/api/portraits/women/79.jpg',
  'u-olivia': 'https://randomuser.me/api/portraits/women/58.jpg',
  'u-casey': 'https://randomuser.me/api/portraits/women/72.jpg',
}

const oldDuplicateDefaults: Record<string, string> = {
  'u-lillian': 'https://randomuser.me/api/portraits/women/44.jpg',
  'u-olivia': 'https://randomuser.me/api/portraits/women/65.jpg',
  'u-casey': 'https://randomuser.me/api/portraits/women/68.jpg',
}

try {
  for (const [userId, url] of Object.entries(demoPhotos)) {
    const key = `schub.profilePhoto.${userId}`
    const current = appStorage.getItem(key)

    // Keep any photo the user uploaded/changed themselves. Only replace the old
    // duplicated stock defaults that matched adult demo profiles.
    if (!current || current === oldDuplicateDefaults[userId]) {
      appStorage.setItem(key, url)
    }
  }
} catch {
  // Browser storage may be unavailable in non-browser build contexts.
}

